// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2isjh","toggle":"styles_toggle__3V3KW","preview":"styles_preview__3Yzlf"};